import { render, staticRenderFns } from "./productsMostSaled.vue?vue&type=template&id=0bfc7914&scoped=true&"
import script from "./productsMostSaled.vue?vue&type=script&lang=js&"
export * from "./productsMostSaled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc7914",
  null
  
)

export default component.exports